import React from 'react';
import { Grid, GridColumn, Separator, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { replaceDotsAndFormatToCustomDecimalPlaceRoundingUp } from '../util/PriceUtil';
import { Prices } from './MeluCalculator';
import { resolveCallsPrice, resolveInternetDataPrice } from './MeluDataUtil';
import { observer } from 'mobx-react';
import MeluSelectedItems from './MeluSelectedItems';

interface Props {
  internetDeviceCount: number;
  callsDeviceCount: number;
  internetDataAmount: number;
  roamingDataAmount: string;
  prices?: Prices;
}

const MeluCalculationCollapseContent = (props: Props): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const { internetDataAmount, roamingDataAmount, internetDeviceCount, callsDeviceCount, prices } = props;
  const shouldShowPricesPerDevice = !(internetDeviceCount === 1 && callsDeviceCount === 0);
  return (
    <Text>
      <Grid noWrap={true}>
        <GridColumn width={['max-xs']}>
          {translate(`meluCalculator.calculationCollapse.dataAmountLabel${[100, 101].includes(internetDataAmount) ? '.unlimited' : ''}`, {
            dataAmount: internetDataAmount,
            roamingDataAmount
          })}
          <p className="text-tiny">{translate('meluCalculator.calculationCollapse.scandinavianCountries')}</p>
        </GridColumn>
        <GridColumn width={['min-xs']} className="text-bold">
          <>{replaceDotsAndFormatToCustomDecimalPlaceRoundingUp(resolveInternetDataPrice(internetDeviceCount, internetDataAmount, prices), 3)}</>
          <> {translate('meluCalculator.summaryTable.eurosPerMonth')}</>
        </GridColumn>
      </Grid>
      {shouldShowPricesPerDevice && (
        <>
          <Separator color="invisible" spacing="small" />
          <Grid noWrap={true}>
            <GridColumn width={['max-xs']}>
              {translate('meluCalculator.calculationCollapse.unlimitedCallsLabel', { callsDeviceCount: internetDeviceCount || 1 })}
            </GridColumn>
            <GridColumn width={['min-xs']} className="text-bold">
              <>{replaceDotsAndFormatToCustomDecimalPlaceRoundingUp(resolveCallsPrice(internetDeviceCount, callsDeviceCount, prices), 3)}</>
              <> {translate('meluCalculator.summaryTable.eurosPerMonth')}</>
            </GridColumn>
          </Grid>
          <Separator color="invisible" spacing="xsmall" />
          <MeluSelectedItems internetDeviceCount={internetDeviceCount} callsDeviceCount={callsDeviceCount} prices={prices} />
        </>
      )}
    </Text>
  );
};

export default observer(MeluCalculationCollapseContent);
